import { AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX } from '../constants';

export default function getMentionRecipientSuggestionId(index: number): string {
    return AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX + index.toString();
}
